import { render, staticRenderFns } from "./AccountMenuContainer.vue?vue&type=template&id=6669769a&scoped=true&"
import script from "./AccountMenuContainer.vue?vue&type=script&lang=js&"
export * from "./AccountMenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./AccountMenuContainer.vue?vue&type=style&index=0&id=6669769a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6669769a",
  null
  
)

export default component.exports